import styles from './PureTextButton.module.scss';

export interface PureTextButtonProps {
    textContent: string;
    onClick: (() => void);
}

const PureTextButton = (props: PureTextButtonProps): React.ReactElement => {
    const { textContent, onClick } = props;

    return (
        <button onClick={onClick} className={styles.pureTextButton}>{textContent}</button>
    );
};

export default PureTextButton;
